module.exports = __webpack_public_path__ + "static/media/buttonc.7f2b557c.svg";